// ATTACHMENTS:
module.exports = [{
  name: "Red Dot",
  src: "attach_0",
  dotSrc: "dot_0",
  aimOffY: 0.16,
  scale: 1.2
}];